import authAxios from './authAxios';

// Per-kind PID status endpoints + whether inactivation is gated by Customer-Spec
// dependents. Methods/PLU/Displays flip freely; UPC and Bags block on → Inactive when a
// non-Inactive Customer Spec references them. Keys: methods=MethodUniqueID,
// bags/plu=LabelID (group), upc/displays=UniqueID (record). Label-keyed endpoints send the
// label as ?labelId= rather than a path segment: the Azure front end decodes %2F before the
// API sees it, so a label containing '/' 404s when passed in the path.
const KINDS = {
  methods:  { patch: (k) => `/api/pidmethods/group/by-id/${encodeURIComponent(k)}/status`, blocks: false },
  bags:     { patch: (k) => `/api/pidbags/by-label/status?labelId=${encodeURIComponent(k)}`,
              deps:  (k) => `/api/pidbags/by-label/dependents?labelId=${encodeURIComponent(k)}`, blocks: true },
  plu:      { patch: (k) => `/api/pidplu/by-label/status?labelId=${encodeURIComponent(k)}`, blocks: false },
  upc:      { patch: (k) => `/api/pidupc/${encodeURIComponent(k)}/status`,
              deps:  (k) => `/api/pidupc/${encodeURIComponent(k)}/dependents`, blocks: true },
  displays: { patch: (k) => `/api/piddisplays/${encodeURIComponent(k)}/status`, blocks: false },
};

// Attempt a PID status change.
//   - Blocking kinds (upc, bags) going → Inactive: GET dependents first; if any
//     non-Inactive Customer Specs reference it, return { blocked: true, dependents }
//     and do NOT change status (caller shows DependentsBlockDialog).
//   - Otherwise PATCH and return { blocked: false }.
// Throws on network/server error so the caller can revert its optimistic state.
export async function changePidStatus(kind, key, next) {
  const cfg = KINDS[kind];
  if (!cfg) throw new Error(`Unknown PID kind: ${kind}`);
  if (next === 'Inactive' && cfg.blocks && cfg.deps) {
    const { data } = await authAxios.get(cfg.deps(key));
    if (data && data.specs && data.specs.count > 0) {
      return { blocked: true, dependents: data };
    }
  }
  await authAxios.patch(cfg.patch(key), { Status: next });
  return { blocked: false };
}
